<template>
  <!-- <v-container grid-list-xl fluid class="pt-0" v-if="totaltotalBillings"> -->
  <v-card class="pt-2 pb-2" :flat="!show">
    <canvas id="billing-chart"></canvas>
    <v-card-actions>
      <v-spacer />
      <v-switch
        v-if="show"
        v-model="stacked"
        label="Empilhado"
        @change="changeChartType(stacked)"
      ></v-switch>
    </v-card-actions>
  </v-card>
  <!-- </v-container> -->
</template>
<script>
import Chart from "chart.js";
import { mapState } from "vuex";
export default {
  data: () => ({
    show: false,
    loading: false,
    stacked: true,
    current_date: new Date(),
    billings: [],
    //   ChartData: ChartData,
    ChartData: {
      type: "bar", // was "line"
      data: {
        labels: [
          "04/2019",
          "05/2019",
          "06/2019",
          "07/2019",
          "08/2019",
          "09/2019",
        ],
        // labels: ['2019', '2019', '2019', '07/2019', '08/2019', '09/2019'],
        datasets: [
          {
            // another line graph
            label: "Saldo",
            type: "line", // Add this
            data: [0],
            borderColor: ["#c8c8c8"],
            borderDash: [5],
            borderWidth: 2,
          },
          {
            // one line graph
            label: "Atrasados",
            type: "bar", // Add this
            // barPercentage: 0.5,
            barThickness: "flex",
            // maxBarThickness: 8,
            minBarLength: 2,
            data: [0],
            backgroundColor: [
              "darkred", // Blue
              "darkred",
              "darkred",
              "darkred",
              "darkred",
            ],
            borderColor: [
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
            ],
            borderWidth: 1,
          },
          {
            // another line graph
            label: "Não Faturado",
            type: "bar", // Add this
            data: [0],
            backgroundColor: [
              "orange",
              "orange",
              "orange",
              "orange",
              "orange",
              // 'rgba(71, 183,132,.5)', // Green
            ],
            borderColor: ["#47b784"],
            borderWidth: 1,
          },
          {
            // another line graph
            label: "Pagos e Abertos",
            type: "bar", // Add this
            data: [0],
            backgroundColor: ["green", "green", "green", "green", "green"],
            borderColor: ["green", "green", "green", "green", "green"],
            borderWidth: 1,
          },
          {
            // another line graph
            label: "Total Faturado",
            type: "line", // Add this
            data: [0],
            // backgroundColor: [
            //     'teal', // Green
            //     'teal',
            //     'teal',
            //     'lightteal',
            //     'lightteal',
            // ],
            // backgroundColor: [
            //     'red', // Green
            // ],
            borderColor: ["black", "black", "lightblue", "black", "black"],
            borderDash: [2, 2, 2, 2, 2],
            borderWidth: 2,
          },
          {
            // another line graph
            label: "Valor a Faturar",
            type: "bar", // Add this
            data: [0],
            backgroundColor: [
              "blue", // Green
              "blue",
              "blue",
              "blue",
              "blue",
            ],
            // backgroundColor: [
            //     'red', // Green
            // ],
            borderColor: ["#808080"],
            // borderDash: [5, 5],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,
        lineTension: 1,
        title: {
          display: true,
          text: "Faturamento por Competencia Mensal",
          fontSize: 20,
          fontStyle: "bold",
          padding: 10,
        },
        // events: ['click'],
        // onClick: function (evt, item) {
        //     console.log('evt: ', evt)
        //     console.log('item: ', item)
        //     // changeCompetence(item[0])
        // },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
              },
              // stacked: true
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
              },
              stacked: true,
            },
          ],
        },
        // tooltips: {
        // Disable the on-canvas tooltip
        //     enabled: false,

        //     custom: function(tooltipModel) {
        //         // Tooltip Element
        //         var tooltipEl = document.getElementById('chartjs-tooltip');

        //         // Create element on first render
        //         if (!tooltipEl) {
        //             tooltipEl = document.createElement('div');
        //             tooltipEl.id = 'chartjs-tooltip';
        //             tooltipEl.innerHTML = '<table></table>';
        //             document.body.appendChild(tooltipEl);
        //         }

        //         // Hide if no tooltip
        //         if (tooltipModel.opacity === 0) {
        //             tooltipEl.style.opacity = 0;
        //             return;
        //         }

        //         // Set caret Position
        //         tooltipEl.classList.remove('above', 'below', 'no-transform');
        //         if (tooltipModel.yAlign) {
        //             tooltipEl.classList.add(tooltipModel.yAlign);
        //         } else {
        //             tooltipEl.classList.add('no-transform');
        //         }

        //         function getBody(bodyItem) {
        //             let _bodyItem = bodyItem.lines[0].split(':')
        //             let _legend = _bodyItem[0]
        //             let _value = 'R$ '+ Number(_bodyItem[1]).toFixed(2).replace('.', ',')
        //             return [_legend + ': ' + _value]
        //             // return bodyItem.lines;
        //         }

        //         // Set Text
        //         if (tooltipModel.body) {
        //             var titleLines = tooltipModel.title || [];
        //             var bodyLines = tooltipModel.body.map(getBody);

        //             var innerHtml = '<thead>';

        //             titleLines.forEach(function(title) {
        //                 innerHtml += '<tr style="background: FFF"><th>' + title + '</th></tr>';
        //             });
        //             innerHtml += '</thead><tbody>';

        //             bodyLines.forEach(function(body, i) {
        //                 var colors = tooltipModel.labelColors[i];
        //                 var style = 'background:' + colors.backgroundColor;
        //                 style += '; border-color:' + colors.borderColor;
        //                 style += '; border-width: 2px';
        //                 var span = '<span style="' + style + '"></span>';
        //                 innerHtml += '<tr><td>' + span + body + '</td></tr>';
        //                 // innerHtml += '<tr><td>' + body + '</td></tr>'
        //             });
        //             innerHtml += '</tbody>';

        //             var tableRoot = tooltipEl.querySelector('table');
        //             tableRoot.innerHTML = innerHtml;
        //         }

        //         // `this` will be the overall tooltip
        //         var position = this._chart.canvas.getBoundingClientRect();

        //         // Display, position, and set styles for font
        //         tooltipEl.style.opacity = 1;
        //         tooltipEl.style.position = 'absolute';
        //         tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        //         tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        //         tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        //         tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        //         tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        //         tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        //         tooltipEl.style.pointerEvents = 'none';
        //     }
        // }
      },
    },
  }),
  computed: {
    ...mapState("billing", ["totalBillings"]),
  },
  watch: {
    async totalBillings() {
      if (this.totalBillings && this.totalBillings.length > 0) {
        this.setChart();
      }
    },
  },
  mounted() {
    // console.log('mounted totalBillings: ', this.totalBillings)
    if (this.totalBillings && this.totalBillings.length > 0) {
      this.setChart();
    }
  },
  // mounted() {
  //     this.createChart('billing-chart', this.ChartData);
  // },
  // async mounted() {
  //     if(await this.totalBillings) {
  //         console.log('passou aqui')
  //     }
  //     // if(this.billings.length > 0) {
  //     //     // console.log('totalBillings: ', this.totalBillings)
  //     //     this.setChart()
  //     // }
  //     if(await typeof(this.totalBillings) !== 'object') {
  //         console.log('totalBillings: ', this.totalBillings)
  //     }
  // },
  // watch: {
  //     async totalBillings() {
  //         console.log('watch: ', typeof(this.totalBillings))
  //         // if(this.totalBillings && this.totalBillings.length > 0) {
  //         if(await typeof(this.totalBillings) !== 'object') {
  //             console.log('watch2: ', this.totalBillings)
  //             this.billings = this.totalBillings
  //             this.setChart()
  //         }
  //     }
  // },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      // eslint-disable-next-line
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
    async setChart() {
      // if(this.totalBillings && this.) {
      this.loading = true;
      var competence_labels = this.totalBillings.map((val) => {
        const month = val.competence.split("-")[1];
        const year = val.competence.split("-")[0];
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        return month + "/" + year;
      });
      var receita_liquida = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (val.summarize && val.summarize.receita_liquida)
          return val.summarize.receita_liquida
            ? Number(Number(val.summarize.receita_liquida).toFixed(2))
            : 0;
        else return 0;
      });
      var inadimplencia = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (val.summarize && val.summarize.inadimplencia)
          return Number(val.summarize.inadimplencia.toFixed(2));
        else return 0;
      });

      var creditosFaturados = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (
          val.summarize &&
          val.summarize.inadimplencia &&
          val.summarize.pagamento_Enercred
        )
          return (
            Number(val.summarize.pagamento_Enercred.toFixed(2)) -
            Number(val.summarize.inadimplencia.toFixed(2))
          );
        else return 0;
      });

      var ineficiencia = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (
          val.summarize &&
          val.summarize.creditos_gerados > val.summarize.creditosFaturados
        )
          // return val.summarize.creditos_gerados.toFixed(2) - val.summarize.creditosFaturados.toFixed(2)
          return (
            val.summarize.receita_liquida - val.summarize.pagamento_Enercred
          );
        else return 0;
      });

      var totalFaturado = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (val.summarize && val.summarize.pagamento_Enercred)
          return Number(val.summarize.pagamento_Enercred.toFixed(2));
        else return 0;
      });

      var saldo = this.totalBillings.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        if (val.summarize && val.summarize.saldo)
          return Number(val.summarize.saldo.toFixed(2));
        else return 0;
      });
      // console.log('saldo: ', saldo)

      if (competence_labels && competence_labels.length > 0) {
        // console.log('competence_labels: ', competence_labels)
        this.ChartData.data.labels = competence_labels || [];
      }

      if (totalFaturado && totalFaturado.length > 0) {
        // console.log('creditos_gerados: ', creditos_gerados)
        this.ChartData.data.datasets[4].data = totalFaturado || [];
      }

      if (receita_liquida && receita_liquida.length > 0) {
        // console.log('creditos_gerados: ', creditos_gerados)
        this.ChartData.data.datasets[5].data = receita_liquida || [];
      }

      if (creditosFaturados && inadimplencia.length > 0) {
        // console.log('creditosFaturados: ', creditosFaturados)
        this.ChartData.data.datasets[3].data = creditosFaturados || [];
      }

      if (ineficiencia && ineficiencia.length > 0) {
        // console.log('ineficiencia: ', ineficiencia)
        this.ChartData.data.datasets[2].data = ineficiencia || [];
      }

      if (inadimplencia && inadimplencia.length > 0) {
        // console.log('inadimplencia: ', inadimplencia)
        this.ChartData.data.datasets[1].data = inadimplencia || [];
      }

      if (saldo && saldo.length > 0) {
        // console.log('saldo: ', saldo)
        this.ChartData.data.datasets[0].data = saldo || [];
      }

      this.show = true;
      // console.log('ChartData: ', this.ChartData)
      await this.createChart("billing-chart", this.ChartData);
      this.loading = false;

      // }
    },
    changeChartType(stacked) {
      this.ChartData.options.scales.xAxes[0].stacked = stacked;
      this.createChart("billing-chart", this.ChartData);
    },
  },
};
</script>
